export function convertQueryRequestToQueryParams(request: any) {
  const params: string[] = [];
  Object.keys(request).forEach((key) => {
    const queriesForKey: string[] = [];

    if (typeof request[key] === 'object') {
      Object.keys(request[key]).forEach((subKey) => {
        if (Array.isArray(request[key][subKey])) {
          request[key][subKey].forEach((value: string) => {
            queriesForKey.push(`${key}[${subKey}][]=${value}`);
          });
        } else {
          if (request[key][subKey]) {
            queriesForKey.push(`${key}[${subKey}]=${request[key][subKey]}`);
          }
        }
      });
    } else {
      queriesForKey.push(`${key}=${request[key]}`);
    }
    if (queriesForKey.length > 0) {
      params.push(queriesForKey.join('&'));
    }
  });

  return params.join('&');
}
